<div class="badge-personas-container">
  <!-- Header Section -->
  <div class="personas-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="main-icon">
          <path
            d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z"
          />
        </svg>
      </div>
      <div class="header-text">
        <h1>Choose Registration Form</h1>
        <p>Select which form to design badges for</p>
      </div>
    </div>

    <!-- Back Navigation -->
    <div class="back-navigation">
      <button class="back-btn" (click)="goBackToEvents()">
        <svg viewBox="0 0 24 24" class="back-icon">
          <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
        </svg>
        <span>Select Different Event</span>
      </button>
    </div>
  </div>

  <!-- Personas Grid -->
  <div *ngIf="hasPersonas()" class="personas-wrapper tw-flex tw-flex-wrap">
    <div class="tw-w-full md:tw-w-1/2 md:tw-max-w-1/2 lg:tw-w-1/3 lg:tw-max-w-1/3 tw-p-4" *ngFor="let persona of personas">
      <div
        class="persona-card"
        [class.selected]="selectedPersonaId === persona.id"
        [class]="'status-' + getPersonaStatusColor(persona)"
        (click)="selectPersona(persona)"
      >
        <!-- Status Badge -->
        <div class="status-badge" [class]="'badge-' + getPersonaStatusColor(persona)">
          <svg *ngIf="hasPaymentEnabled(persona)" viewBox="0 0 24 24" class="status-icon">
            <path
              d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"
            />
          </svg>
          <svg *ngIf="requiresApproval(persona) && !hasPaymentEnabled(persona)" viewBox="0 0 24 24" class="status-icon">
            <path
              d="M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14H7V16H9V14M13,14H11V16H13V14M17,14H15V16H17V14Z"
            />
          </svg>
          <svg *ngIf="!hasPaymentEnabled(persona) && !requiresApproval(persona)" viewBox="0 0 24 24" class="status-icon">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
          <span>
            {{ hasPaymentEnabled(persona) ? 'Paid' : requiresApproval(persona) ? 'Approval' : 'Free' }}
          </span>
        </div>

        <!-- Persona Icon -->
        <div class="persona-icon">
          <svg viewBox="0 0 24 24" class="persona-icon-svg">
            <path [attr.d]="getPersonaIcon(persona)" />
          </svg>
        </div>

        <!-- Persona Content -->
        <div class="persona-content">
          <div class="persona-info">
            <h3 class="persona-name" [title]="getPersonaDisplayName(persona)">
              {{ getPersonaDisplayName(persona) }}
            </h3>
            <div class="persona-type">
              <span class="type-label">{{ getPersonaType(persona) }} Form</span>
            </div>

            <!-- Enhanced Information Display -->
            <div class="form-details">
              <!-- Form Fields Summary -->
              <div class="fields-summary">
                <div class="field-count">
                  <svg viewBox="0 0 24 24" class="info-icon">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                  <span>{{ getFormFieldsCount(persona) }} fields</span>
                  <span *ngIf="getRequiredFieldsCount(persona) > 0" class="required-count"> ({{ getRequiredFieldsCount(persona) }} required) </span>
                </div>
              </div>

              <!-- Field Types Preview -->
              <div *ngIf="getFormFieldsCount(persona) > 0" class="field-types">
                <div class="field-chips">
                  <span *ngFor="let fieldType of getFormFieldTypes(persona)" class="field-chip">
                    {{ fieldType }}
                  </span>
                  <span *ngIf="hasMoreFields(persona)" class="more-chip"> +{{ getExtraFieldsCount(persona) }} more </span>
                </div>
              </div>

              <!-- Payment Information -->
              <div *ngIf="hasPaymentEnabled(persona)" class="payment-info">
                <div class="price-display">
                  <span class="amount">{{ getCurrencySymbol(persona) }}{{ getRegistrationAmount(persona) }}</span>
                </div>
              </div>

              <!-- Registration Limits -->
              <div *ngIf="hasRegistrationLimits(persona)" class="registration-limit">
                <svg viewBox="0 0 24 24" class="limit-icon">
                  <path
                    d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"
                  />
                </svg>
                <span>Max {{ getMaxRegistrations(persona) }} registrations</span>
              </div>

              <!-- Public Description -->
              <div *ngIf="hasPublicDescription(persona)" class="public-description">
                <p>{{ getPublicDescription(persona) }}</p>
              </div>
            </div>
          </div>

          <div class="edit-button">
            <svg viewBox="0 0 24 24" class="edit-icon">
              <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
            </svg>
            <span>Edit Badge</span>
          </div>
        </div>

        <!-- Selection Indicator -->
        <div class="selection-indicator">
          <svg viewBox="0 0 24 24" class="check-icon">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!hasPersonas()" class="empty-state">
    <div class="empty-illustration">
      <svg viewBox="0 0 24 24" class="empty-icon">
        <path
          d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z"
        />
      </svg>
    </div>
    <h3>No Registration Forms</h3>
    <p>This event doesn't have any registration forms yet.</p>
    <div class="empty-actions">
      <button class="back-btn" (click)="goBackToEvents()">
        <svg viewBox="0 0 24 24">
          <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
        </svg>
        Choose Different Event
      </button>
    </div>
  </div>
</div>
